import axios from "axios";

localStorage.setItem(
  "token",
  "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IlBrRVdIbzBBMGpTZEs0MFd6NkRqWCJ9.eyJpc3MiOiJodHRwczovL3VyLWdhcnkuZXUuYXV0aDAuY29tLyIsInN1YiI6ImF1dGgwfDYxMDBmYTUwYzA0MGU4MDA2ODYxYjM3ZiIsImF1ZCI6WyJnZ3MiLCJodHRwczovL3VyLWdhcnkuZXUuYXV0aDAuY29tL3VzZXJpbmZvIl0sImlhdCI6MTY0NTUyMTUzOCwiZXhwIjoxNjQ1NjA3OTM4LCJhenAiOiJmNXVPMllXZ2V4eUdEb1REY0VXZ0d2WEt4WWpjamIxMiIsInNjb3BlIjoib3BlbmlkIHByb2ZpbGUgb2ZmbGluZV9hY2Nlc3MiLCJwZXJtaXNzaW9ucyI6W119.JFJG0fhgcbeq2HEEyBZE9_LsqwinjtX_u7eXDPHvzIWqzNFnBVMnnWcPUiY9Jjs6fCL_9SxNAPOgDovEnuvQVAM6_xxpfDTnikDhMsIm3Tbla0zrdJW2PpYOBVjAcpdqeLdTLFSOO56h4x35hefnQ0W-malOwzlRoD5-7C7AL6BE1wzf4qpIro1BrgxLU5TMpuoQYUwYRtHyn_RUusFHZTtzkKrvaOUaYr_apfR6lAKzNr5crsn1AOZ-ONYpEmnhAHGtURN0dqbhs5z5qQPjuMOXL1eX7CCOCivJFqs2D2m8Uu6N-bXasonc4kd-ixoYs79XtqKrkcBg_qL7BLlSEg",
);

localStorage.setItem(
  "serverToken",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzZXJpYWxOdW1iZXJzIjpbIjEwMjMzMCIsIjExMTExMSIsIjEyMzQ1NiJdLCJ1c2VySWQiOiIxOGExYTMwZS1hYTNkLTRiMjQtYjg4ZS04MTA2MzliOGE1YzEiLCJpYXQiOjE2NDQ4NDY3NzAsImV4cCI6MTY0NzQzODc3MH0.1Gunspi7OJ5egxBc1i_-EqEcAH3LJW-CxlFUSTEHtpk",
);

const setupAxiosMarketplaceInterceptors = (config) => {
  if (!config.headers.Authorization) {
    const token = localStorage.getItem("serverToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }

  return config;
};

const setupAxiosInterceptors = (config) => {
  if (!config.headers.Authorization) {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }

  return config;
};

const setupAxiosGGSInterceptors = (config) => {
  if (!config.headers.Authorization) {
    const token = localStorage.getItem("ggsToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }

  return config;
};

const setupAxiosOnReject = (error) => Promise.reject(error.response);

export const axiosMarketplace = axios.create({
  baseURL: "https://dev.robotics.dev.webiz.ge/",
  timeout: 30000,
});
axiosMarketplace.interceptors.request.use(setupAxiosMarketplaceInterceptors, setupAxiosOnReject);

export const axiosGgs = axios.create({
  baseURL: localStorage.getItem("GGS_base_url") || "http://localhost:8000",
  timeout: 30000,
  headers: { Authorization: `Bearer ${localStorage.getItem("ggsToken")}` },
});
axiosGgs.interceptors.request.use(setupAxiosGGSInterceptors, setupAxiosOnReject);

export const axiosChestEngine = axios.create({
  baseURL: process.env.REACT_APP_CHEST_ENGINE_URL || "http://localhost:3001",
  timeout: 30000,
});
axiosChestEngine.interceptors.request.use(setupAxiosInterceptors, setupAxiosOnReject);
